import { z } from 'zod';
/**
 * Activity type from backend API
 * Structure: { Activity: {...}, Product: {...}, User: {...} }
 */
export var ActivityDataSchema = z.object({
    id: z.union([z.number(), z.string()]),
    amount: z.coerce.number(),
    created: z.string(),
    value: z.union([z.number(), z.string()])
});
export var ActivitySchema = z.object({
    Activity: ActivityDataSchema,
    Product: z.object({
        name: z.string()
    }),
    User: z.object({
        display_name: z.string()
    })
});
/**
 * Activity submission for scoring
 */
export var ActivitySubmissionSchema = z.object({
    product_name: z.string(),
    trackable_id: z.number(),
    quantity: z.number(),
    value: z.number(),
    memo: z.string().nullable(),
    user_id: z.number().optional(),
    created: z.string().optional()
});
